webpackJsonp([314],{

/***/ 1316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersOperateDetail_vue__ = __webpack_require__(3087);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0f4e278_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersOperateDetail_vue__ = __webpack_require__(5789);
function injectStyle (ssrContext) {
  __webpack_require__(5787)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c0f4e278"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersOperateDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0f4e278_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersOperateDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3087:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { echarts: __WEBPACK_IMPORTED_MODULE_1_echarts___default.a },
  data: function data() {
    return {
      id: this.$route.query.userid || 0,
      detailData: {
        believable: null,
        is_super: null,
        super_attr: [],
        complete_order_num: 0,
        uncomplete_order_num: 0,
        rejectedTimes: 0,
        work_type: 0,
        belongto: null,
        referrer_belongto: null
      },
      refundRate: 0,
      table: [{
        key: 'believable',
        label: '是否为可信用户'
      }, {
        key: 'is_super',
        label: '是否为超级零工'
      }, {
        key: 'super_attr',
        label: '超级零工属性'
      },
      // {
      //   key: 'work_type',
      //   label: '工种',
      // },
      // {
      //   key: 'belongto',
      //   label: '厂家',
      // },
      {
        key: 'referrer_belongto',
        label: '厂家关联'
      }, {
        key: 'task_all',
        label: '主平台任务总览'
      }]

    };
  },
  created: function created() {
    if (this.id) {
      this.setFormData(this.id);
    }
  },

  computed: Vuex.mapState({
    options: function options(state) {
      return state.users.userOptions;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), {
    ifKey: function ifKey(scope, name) {
      return scope.row.key === name;
    },
    setFormData: function setFormData(id) {
      var _this = this;

      request.page('getUserOperate', id).then(function (_ref) {
        var data = _ref.data;

        filter.setLoop(_this.detailData, data);
        if (_this.detailData.complete_order_num + _this.detailData.uncomplete_order_num === 0) {
          _this.refundRate = 0;
        } else {
          _this.refundRate = ((_this.detailData.rejectedTimes / _this.detailData.complete_order_num + _this.detailData.uncomplete_order_num) * 100).toFixed(2);
        }

        _this.$nextTick(function () {
          _this.buildEchart();
        });
      });
    },
    buildEchart: function buildEchart() {
      var chart = __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.init(this.$refs.echartMain);
      var options = {
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c}单 <br/>({d}%)'
        },
        legend: {
          data: ['完成数', '未完成']
        },
        series: [{
          type: 'pie',
          data: [{
            value: this.detailData.complete_order_num,
            name: '完成数',
            itemStyle: {
              normal: { color: 'rgb(107,197,254)' }
            }
          }, {
            value: this.detailData.uncomplete_order_num,
            name: '未完成',
            itemStyle: {
              normal: { color: 'rgb(255,152,44)' }
            }
          }]
        }]
      };
      chart.setOption(options);
    }
  })
});

/***/ }),

/***/ 5787:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5788);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("c553acf0", content, true, {});

/***/ }),

/***/ 5788:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"UsersOperateDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5789:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('el-row',{staticClass:"sj-container"},[_c('el-table',{attrs:{"highlight-current-row":true,"data":_vm.table,"show-header":false,"border":""}},[_c('el-table-column',{attrs:{"width":"150","prop":"label"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(scope.row.label))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.ifKey(scope,'believable') || _vm.ifKey(scope,'is_super'))?_c('span',[(_vm.detailData[scope.row.key] === 1)?_c('span',[_c('el-button',{attrs:{"type":"primary","round":"","disabled":"","size":"mini"}},[_vm._v("YES")]),_vm._v(" "),_c('el-button',{attrs:{"type":"info","round":"","disabled":"","size":"mini"}},[_vm._v("NO")])],1):_vm._e(),_vm._v(" "),(_vm.detailData[scope.row.key] === 0)?_c('span',[_c('el-button',{attrs:{"type":"info","round":"","disabled":"","size":"mini"}},[_vm._v("YES")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","round":"","disabled":"","size":"mini"}},[_vm._v("NO")])],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.ifKey(scope,'super_attr'))?_c('span',_vm._l((_vm.detailData[scope.row.key]),function(value){return _c('span',_vm._l((_vm.options[scope.row.key]),function(option){return (option.id === value)?_c('span',[_c('el-tag',[_vm._v(_vm._s(option.keyword))]),_vm._v("    \n                ")],1):_vm._e()}),0)}),0):_vm._e(),_vm._v(" "),(_vm.ifKey(scope,'work_type'))?_c('span',_vm._l((_vm.options[scope.row.key]),function(option){return (option.id === _vm.detailData[scope.row.key])?_c('span',[_c('span',[_vm._v(_vm._s(option.keyword))])]):_vm._e()}),0):_vm._e(),_vm._v(" "),(_vm.ifKey(scope,'belongto') || _vm.ifKey(scope,'referrer_belongto'))?_c('span',[_c('span',[_vm._v(_vm._s(_vm.detailData[scope.row.key]))])]):_vm._e(),_vm._v(" "),(_vm.ifKey(scope,'task_all'))?_c('span',[_c('div',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v("总数量: "+_vm._s(_vm.detailData.complete_order_num+_vm.detailData.uncomplete_order_num))]),_vm._v(" "),_c('div',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v("完成数量: "+_vm._s(_vm.detailData.complete_order_num))]),_vm._v(" "),_c('div',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v("退单数量: "+_vm._s(_vm.detailData.rejectedTimes))])]):_vm._e()]}}])})],1)],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('div',{ref:"echartMain",staticStyle:{"width":"100%","height":"400px"}}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","font-size":"16px"}},[_vm._v("总单数:\n      "+_vm._s(_vm.detailData.complete_order_num+_vm.detailData.uncomplete_order_num)+"单\n    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","font-size":"16px"}},[_vm._v("退单率: "+_vm._s(_vm.refundRate)+"%")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/users-operate.b4ee21919ecbdc3fc9db.js